import { render, staticRenderFns } from "./SalesDeliveryItem.vue?vue&type=template&id=1bd1d62a&"
import script from "./SalesDeliveryItem.vue?vue&type=script&lang=ts&"
export * from "./SalesDeliveryItem.vue?vue&type=script&lang=ts&"
import style0 from "./SalesDeliveryItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports